import { storage } from '../../storage';
import { DomainHandler, HandlerContext } from '../../types';
import {
  SAP_IMPORT_STORAGE_KEY,
  SAP_IMPORT_MESSAGE_TYPE,
  SapImportStatusData,
  SapImportStorageState,
} from './sap-import.types';

const lastSignatures = new Map<string, string>();
const pendingTaskRequests = new Map<string, string>();

export function setPendingTaskRequest(storageKey: string, taskId: string): void {
  pendingTaskRequests.set(storageKey, taskId);
}

function isValidMessage(msg: unknown): msg is { type: string; data: Record<string, unknown> } {
  if (typeof msg !== 'object' || msg === null) return false;
  const m = msg as Record<string, unknown>;
  return m.type === SAP_IMPORT_MESSAGE_TYPE && typeof m.data === 'object' && m.data !== null;
}

function buildSignature(data: SapImportStatusData): string {
  return JSON.stringify({
    task_id: data.task_id,
    run_id: data.run_id ?? null,
    rfc_type: data.rfc_type,
    status: data.status,
    error: data.error ?? data.error_message ?? null,
  });
}

export const sapImportHandler: DomainHandler = {
  onOpen(ctx: HandlerContext): void {
    const key = ctx.descriptor.storageKey;
    const pending = pendingTaskRequests.get(key);
    if (pending) {
      ctx.send({ action: 'get_status', task_id: pending });
      pendingTaskRequests.delete(key);
    }
  },

  onMessage(msg: unknown, ctx: HandlerContext): boolean {
    if (!isValidMessage(msg)) return false;

    const key = ctx.descriptor.storageKey;
    const data = msg.data as SapImportStatusData;
    const rfcType = data.rfc_type;

    if (!rfcType) return false;

    const signature = buildSignature(data);
    if (signature === lastSignatures.get(key)) return false;
    lastSignatures.set(key, signature);

    const prev = storage.get<SapImportStorageState>(SAP_IMPORT_STORAGE_KEY) ?? {};
    storage.set(SAP_IMPORT_STORAGE_KEY, { ...prev, [rfcType]: data });

    return false;
  },

  onClose(_event: CloseEvent, ctx: HandlerContext): void {
    const key = ctx.descriptor.storageKey;
    lastSignatures.delete(key);
    pendingTaskRequests.delete(key);
  },
};
